export const OPEN_OVERLAY = "OPEN_OVERLAY"
export const CLOSE_OVERLAY = "CLOSE_OVERLAY"

export const withEventSpace = (eventSpace, event) => {
  return eventSpace + "_" + event
}
